import * as React from "react";
import { createContext, useContext } from "react";

export type Step = "VERIFY_IDENTITY" | "ENTER_PHONE" | "VERIFY_PHONE";

export interface SmsSetupContextValue {
  step: Step;
  setStep: (step: Step) => void;
  phone: string;
  setPhone: (phone: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export const SmsSetupContext = createContext<SmsSetupContextValue | undefined>(undefined);

export const useSmsSetup = () => {
  const context = useContext(SmsSetupContext);
  if (!context) {
    throw new Error("useSmsSetup must be used within an SmsSetupProvider");
  }
  return context;
};
